import React from "react";

function SchoolIcon(props) {
  let colors = {
    mainColor: props.color || "white",
  };

  return (
    <svg
      version="1.1"
      id="Layer_1"
      x="0px"
      y="0px"
      viewBox="0 0 64.024 64.024"
      fill={colors.mainColor}
    >
      <g>
        <g>
          <path
            d="M63.976,31.636c-0.002-0.005,0.036-0.011,0.036-0.017c0,0,0-0.001,0-0.002l-6.041-14
			c-0.157-0.367-0.559-0.605-0.959-0.605H35.483l-2.471-4.268V8.012h9c0.553,0,1-0.448,1-1v-6c0-0.552-0.447-1-1-1h-10
			c-0.553,0-1,0.448-1,1v6v5.732l-2.471,4.268H7.012c-0.4,0-0.802,0.238-0.96,0.606l-6.04,14c0,0.001,0,0.001,0,0.002
			c0,0.005,0.038,0.011,0.036,0.016C0.003,31.744,0.005,31.857,0,31.97c-0.001,0.015,0.012,0.027,0.012,0.042v31
			c0,0.552,0.447,1,1,1h20h7h8h7h20c0.553,0,1-0.448,1-1v-31c0-0.015,0.012-0.027,0.012-0.042
			C64.019,31.857,64.02,31.744,63.976,31.636z M33.012,2.012h8v4h-8V2.012z M33.012,16.735l4.213,7.277h-4.213V16.735z
			 M33.012,26.012h5.371l2.895,5h-8.266V26.012z M31.012,16.735v7.277h-4.213L31.012,16.735z M31.012,26.012v5h-8.266l2.895-5
			H31.012z M20.012,62.012h-18v-29h18V62.012z M20.435,31.012H2.528l5.143-12h19.712L20.435,31.012z M35.012,62.012h-6v-15h6V62.012
			z M42.012,62.012h-5v-15h2v-2h-3h-8h-3v2h2v15h-5v-29h20V62.012z M36.641,19.012h19.712l5.143,12H43.588L36.641,19.012z
			 M62.012,62.012h-18v-29h18V62.012z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M51.012,35.012h-4c-0.553,0-1,0.448-1,1v6c0,0.552,0.447,1,1,1h4c0.553,0,1-0.448,1-1v-6
			C52.012,35.46,51.565,35.012,51.012,35.012z M50.012,41.012h-2v-4h2V41.012z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M59.012,35.012h-4c-0.553,0-1,0.448-1,1v6c0,0.552,0.447,1,1,1h4c0.553,0,1-0.448,1-1v-6
			C60.012,35.46,59.565,35.012,59.012,35.012z M58.012,41.012h-2v-4h2V41.012z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M51.012,45.012h-4c-0.553,0-1,0.448-1,1v6c0,0.552,0.447,1,1,1h4c0.553,0,1-0.448,1-1v-6
			C52.012,45.46,51.565,45.012,51.012,45.012z M50.012,51.012h-2v-4h2V51.012z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M59.012,45.012h-4c-0.553,0-1,0.448-1,1v6c0,0.552,0.447,1,1,1h4c0.553,0,1-0.448,1-1v-6
			C60.012,45.46,59.565,45.012,59.012,45.012z M58.012,51.012h-2v-4h2V51.012z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M9.012,35.012h-4c-0.553,0-1,0.448-1,1v6c0,0.552,0.447,1,1,1h4c0.553,0,1-0.448,1-1v-6
			C10.012,35.46,9.565,35.012,9.012,35.012z M8.012,41.012h-2v-4h2V41.012z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M17.012,35.012h-4c-0.553,0-1,0.448-1,1v6c0,0.552,0.447,1,1,1h4c0.553,0,1-0.448,1-1v-6
			C18.012,35.46,17.565,35.012,17.012,35.012z M16.012,41.012h-2v-4h2V41.012z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M9.012,45.012h-4c-0.553,0-1,0.448-1,1v6c0,0.552,0.447,1,1,1h4c0.553,0,1-0.448,1-1v-6
			C10.012,45.46,9.565,45.012,9.012,45.012z M8.012,51.012h-2v-4h2V51.012z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M17.012,45.012h-4c-0.553,0-1,0.448-1,1v6c0,0.552,0.447,1,1,1h4c0.553,0,1-0.448,1-1v-6
			C18.012,45.46,17.565,45.012,17.012,45.012z M16.012,51.012h-2v-4h2V51.012z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M32.012,35.012c-2.206,0-4,1.794-4,4s1.794,4,4,4s4-1.794,4-4S34.218,35.012,32.012,35.012z M32.012,41.012
			c-1.103,0-2-0.897-2-2s0.897-2,2-2c1.102,0,2,0.897,2,2S33.114,41.012,32.012,41.012z"
          />
        </g>
      </g>
      <g>
        <g>
          <rect x="3.012" y="6.012" width="2" height="2" />
        </g>
      </g>
      <g>
        <g>
          <rect x="7.012" y="6.012" width="2" height="2" />
        </g>
      </g>
      <g>
        <g>
          <rect x="11.012" y="6.012" width="2" height="2" />
        </g>
      </g>
      <g>
        <g>
          <rect x="11.012" y="11.012" width="2" height="2" />
        </g>
      </g>
      <g>
        <g>
          <rect x="15.012" y="11.012" width="2" height="2" />
        </g>
      </g>
      <g>
        <g>
          <rect x="19.012" y="11.012" width="2" height="2" />
        </g>
      </g>
      <g>
        <g>
          <rect x="46.012" y="4.012" width="2" height="2" />
        </g>
      </g>
      <g>
        <g>
          <rect x="50.012" y="4.012" width="2" height="2" />
        </g>
      </g>
      <g>
        <g>
          <rect x="54.012" y="4.012" width="2" height="2" />
        </g>
      </g>
      <g>
        <g>
          <rect x="54.012" y="10.012" width="2" height="2" />
        </g>
      </g>
      <g>
        <g>
          <rect x="58.012" y="10.012" width="2" height="2" />
        </g>
      </g>
      <g>
        <g>
          <rect x="62.012" y="10.012" width="2" height="2" />
        </g>
      </g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
    </svg>
  );
}

export default SchoolIcon;
